import styled, { css } from 'styled-components';
import { layout } from '../../styles/layout';

export interface FeatureListEntryContainerProps {
  textOrientation?: 'left' | 'right';
}

export const FeatureListEntryContainer = styled.div<FeatureListEntryContainerProps>`
  display: grid;
  padding: 3em 0 2em 0;
  ${({ textOrientation }) => textOrientation === 'left' ?
    css`
    grid-template-columns: 840px 1fr;
    grid-template-areas: "featureImage featureText";

    @media all and (max-width: ${layout.xlg}) {
      grid-template-columns: 1fr 600px;
    }
    @media all and (max-width: ${layout.lg}) {
      grid-template-columns: 1fr 440px;
    }
    @media all and (max-width: ${layout.md}) {
      grid-template-columns: 1fr 400px;
    }

    ` :
    css`
    grid-template-columns: 1fr 840px;
    grid-template-areas: "featureText featureImage";

    @media all and (max-width: ${layout.xlg}) {
      grid-template-columns: 600px 1fr;
    }
    @media all and (max-width: ${layout.lg}) {
      grid-template-columns: 440px 1fr;
    }
    @media all and (max-width: ${layout.md}) {
      grid-template-columns: 400px 1fr;
    }
  `
}
  @media all and (max-width: ${layout.subMd}) {
    grid-template-columns: 1fr;
    grid-template-areas: "featureText" "featureImage";
  }
`

export const FeatureListEntryImage = styled.div`
  grid-area: featureImage;
  align-self: center;
  justify-self: center;
  max-width: 90vw;
  width: 100%;
  display: grid;
  justify-content: center;
`

export const FeatureListEntryTextBlock = styled.div<FeatureListEntryContainerProps>`
  grid-area: featureText;
  display: grid;
  align-self: center;
  row-gap: 22px;
  ${({ textOrientation }) => textOrientation === 'left' ? 'padding-right: 3em' : 'padding-left: 3em'};
  @media all and (max-width: ${layout.subMd}) {
    justify-self: center;
    padding: 0px 4.5em;
    p, h1 {
      text-align: center;
    }
  }
`
